export default __webpack_public_path__ + "static/media/country.62a0c9c9.jpg";